import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { orderCard } from './reducer';
import { CardPaymentMethods } from '../../../screens/Card/CardOrder/addCardOrder/constants';

const initOrderCardState = {
  currentScreen: null,
  screenOptions: {},
  forceUpdate: {
    mainCardType: false,
    cardType: false,
    paymentMethodType: false,
    paymentCurrency: false,
  },
  forceReset: {},
  user: null,
  cardHolderName: null,
  cardOrderSettings: {
    server: null,
    ui: null,
    app: null,
    contentUrls: null,
    pgw: null,
  },
  cardIssueOptions: null,
  regionSettings: null,
  mainCardType: null,
  cardType: null,
  cardProvider: null,
  cardOptions: null,
  cardProvidersWithTypesObj: null,
  cardOrderFee: null,
  cardCurrency: { coin: null },
  cardNetwork: null,
  payment: {
    type: '',
    method: CardPaymentMethods.PGW,
    currency: '',
  },
  freeCardEligible: { isEligible: false, isWaitingList: false, forType: '', eligible: null },
  userWallets: [],
  chosenWalletForPayment: null,
  accountMailingAddress: null,
  isCardReplacement: null,
  orderableCardTypes: null,
};

export const OrderCardContext = createContext(initOrderCardState);

export const OrderCardProvider = ({ children }) => {
  const [state, dispatch] = useReducer(orderCard?.OrderCardReducer, initOrderCardState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in orderCard?.actions) {
    boundActions[key] = orderCard.actions[key](dispatch);
  }

  return (
    <OrderCardContext.Provider value={{ state, ...boundActions }}>
      {children}
    </OrderCardContext.Provider>
  );
};

OrderCardProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
